/**
 * Λατινικά κεφαλαία γράμματα που είναι οπτικά πανομοιότυπα με κάποιο
 * ελληνικό κεφαλαίο γράμμα σε (σχεδόν) κάθε γραμματοσειρά — π.χ. λατινικό
 * 'A' (U+0041) εναντίον ελληνικού 'Α' (U+0391, Alpha). Ο χρήστης δεν μπορεί
 * να δει τη διαφορά στην οθόνη, αλλά για τον υπολογιστή είναι δύο εντελώς
 * διαφορετικοί χαρακτήρες — αν ένα πρόγραμμα γράφτηκε με ακούσια εναλλαγή
 * γλώσσας πληκτρολογίου (π.χ. "Α[1] ← 3" ελληνικά αλλά "Α[i]" αλλού
 * λατινικά), δύο "ίδιες" μεταβλητές θα ήταν στην πραγματικότητα άσχετες.
 *
 * Κανονικοποιούμε προς τα ελληνικά (η γλώσσα βάση των δεσμευμένων λέξεων)
 * ώστε αναγνωριστικά με τέτοια ακούσια ανάμειξη χαρακτήρων να λειτουργούν
 * όπως τα βλέπει ο χρήστης, αντί να παράγουν παραπλανητικά "μη
 * αρχικοποιημένη μεταβλητή" σφάλματα.
 */
const LATIN_TO_GREEK_HOMOGLYPHS: Readonly<Record<string, string>> = {
  A: 'Α',
  B: 'Β',
  E: 'Ε',
  Z: 'Ζ',
  H: 'Η',
  I: 'Ι',
  K: 'Κ',
  M: 'Μ',
  N: 'Ν',
  O: 'Ο',
  P: 'Ρ',
  T: 'Τ',
  Y: 'Υ',
  X: 'Χ',
};

/** Αντικαθιστά λατινικά ομοιόμορφα γράμματα με τα ελληνικά αντίστοιχά τους μέσα σε ένα αναγνωριστικό. */
export function normalizeIdentifierText(text: string): string {
  let result = '';
  for (const ch of text) {
    result += LATIN_TO_GREEK_HOMOGLYPHS[ch] ?? ch;
  }
  return result;
}
